'use client';
import React, { useEffect } from 'react';
import { PlayCircleIcon } from '@heroicons/react/20/solid';
import { VIDEO_ID } from '@/lib/constants';
import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';
import { copyVideoSection } from '@/sections/develocity/VideoSection/videoSection.copy';
import { useVideoSectionAnimation } from './useVideoSectionAnimation';

interface BackgroundVideoProps {
  src: string;
  className: string;
  key: string;
}

export const VideoSection = (params: { play: string | string[] | undefined }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { title, videoLink, button, backgroundVideo } = copyVideoSection;
  const [isOpen, setOpen] = React.useState<boolean>(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const renderBackgroundVideo = ({ src, className, key }: BackgroundVideoProps) => (
    <div className={className} key={`bgVideo-${key}`}>
      <video muted autoPlay loop height={'100%'} width={'100%'} playsInline>
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );

  useVideoSectionAnimation(ref);

  useEffect(() => {
    params.play === VIDEO_ID && openModal();
  }, [params.play]);

  return (
    <div className="hero relative text-white will-change-transform" ref={ref}>
      <div
        className={`videoBackground w-full scale-90 transform via-transparent before:absolute before:-bottom-1 before:left-0 before:h-[var(--heightBg)] before:w-full before:bg-gradient-to-t before:from-black before:to-transparent`}
      >
        {backgroundVideo.map((video, index) =>
          renderBackgroundVideo({
            ...video,
            key: 'video-background-' + index,
          }),
        )}
      </div>
      <div className="hero-content text-center">
        <div className="max-w-4xl">
          <h4 className="text-h6 mb-8">{title}</h4>

          <button className="group mx-auto flex items-center gap-2" onClick={openModal}>
            <PlayCircleIcon className="mt-0.5 size-5 text-gradle-blue" />
            <span className="underline-text-transition-blue">{button}</span>
          </button>
          <ModalVideoPlayer isOpen={isOpen} videoLink={videoLink} onClose={closeModal} />
        </div>
      </div>
    </div>
  );
};
